module.exports = __webpack_public_path__ + "img/demo01.9a88fbf4.png";